/* eslint no-template-curly-in-string: 0 */

import { PAYMENT_STATUSES } from "../../../../utils/enums";

export const paypalAdaptive = {
  id: "PAYPAL_ADAPTIVE_PAYMENTS",
  displayName: "PayPal",
  paymentFlow: "oauth",
  cssClassPrefix: "paypal",
  themeColor: "#009cde",
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "Con el fin de entregar el pago directamente a su cuenta con estos servicios, usted debe (a) verificar su identidad y (b) permitirnos recibir información sobre su cuenta de PayPal. Por favor, tenga en cuenta que el proceso de inicio de sesión es provisto por PayPal y que ${programName} nunca ve o recibe la información de acceso. Todas estas acciones emplean métodos de seguridad estándares de la industria para garantizar que sus datos estén protegidos.",
          question: "¿Por qué se me pide proporcionar mi nombre de usuario y contraseña para las formas de pago de PayPal®?"
        }
      ]
    }
  },
  paywall: {
    tile: {
      displayName: ["PayPal"],
      tagline: ["Fondos de disponibilidad inmediata"],
      description: [
        {
          string: "Depósito directo a su cuenta de PayPal verificada",
          type: "div",
        },
      ],
    }
  },
  recipientLogin: {
    flow: "oauth",
    redirectingToOauth: {
      title: "Redirigiéndole a PayPal"
    },
  },
  acceptPayment: {
    btnLabel: "Aplicar a ${paymentNetwork.displayName}",
    byCurrencySelector: {
      RECIPIENT: {
        flow: 'select-currency',
      },
      CUSTOMER: {
        flow: "auto-accept",
      }
    }
  },
  paymentComplete: {
    actions: [
      {
        type: "Button",
        props: {
          label: "Compre ahora en PayPal",
          href: "https://www.paypal-gifts.com/"
        }
      },
      {
        type: "Button",
        props: {
          label: "Ver el Saldo de PayPal",
          inverted: true,
          href: "https://www.paypal.com/myaccount/home"
        }
      }
    ],
    affiliateLink: "https://www.paypal.com",
    createAccountLink: "https://www.paypal.com/signup/accountCreate",
    forgotAccountLink:
      "https://www.paypal.com/webapps/accountrecovery/passwordrecovery"
  },
  errors: {
    acceptPayment: {
      title: "Error al Transferir los Fondos",
      message:
        "Se produjo un error al aplicar el crédito a la cuenta de PayPal especificada. Por favor, seleccione una forma de pago diferente."
    }
  }
};

export default paypalAdaptive
